import React from "react";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";
import { Icon } from "./icon";
import classnames from "classnames";

interface CheckboxProps {
  testID?: string;
  value?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  isInvalid?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  borderRef?: React.LegacyRef<HTMLDivElement>;
}

export function Checkbox(props: CheckboxProps) {
  const {
    testID,
    value,
    onChange = () => {},
    disabled,
    isInvalid,
    onBlur,
    borderRef,
  } = props;
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <div
      style={styles(
        "root",
        value ? "rootChecked" : "rootUnchecked",
        isFocused && "focused",
        disabled && "disabled",
        isInvalid && "isInvalid"
      )}
      className={classnames(
        "checkbox-root",
        value ? "checkbox-root-checked" : "checkbox-root-unchecked",
        isFocused && "checkbox-focused",
        disabled && "checkbox-disabled"
      )}
      ref={borderRef}
    >
      <input
        style={styles("input")}
        data-testid={testID}
        type="checkbox"
        checked={value}
        onChange={() => onChange(!value)}
        onFocus={() => setIsFocused(true)}
        onBlur={(event) => {
          setIsFocused(false);
          onBlur?.(event);
        }}
      />
      {value && (
        <div style={styles("checkmark")}>
          <Icon name="check" color="white" size={16} />
        </div>
      )}
    </div>
  );
}

const styles = stylex.create({
  root: {
    position: "relative",
    borderRadius: cssVariables.radius,
    width: 24,
    height: 24,
    transition: "0.2s",
    boxSizing: "border-box",
    border: `2px solid transparent`,
  },
  rootChecked: {
    backgroundColor: cssVariables.backgroundPrimary,
  },
  rootUnchecked: {
    border: `2px solid ${cssVariables.borderColorDark}`,
  },
  focused: {
    border: `2px solid ${cssVariables.borderColorFocus}`,
  },
  disabled: {
    backgroundColor: cssVariables.backgroundGrey,
  },
  isInvalid: {
    border: `2px solid ${cssVariables.borderColorDanger}`,
  },
  input: {
    opacity: 0,
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    position: "relative",
    zIndex: 1,
    cursor: "pointer",
  },
  checkmark: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
